// extracted by mini-css-extract-plugin
export default {"content":"productPriceListContainer_content__lQ3aW"};